import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { repetirConsulta } from '@/lib/consulta-retry'
import { avisarErro } from '@/lib/erro-visivel'

// Query client com defaults seguros para o domínio financeiro
export function criarQueryClient(): QueryClient {
  return new QueryClient({
    // Mutação que falha sem onError próprio não avisava ninguém: o usuário via a
    // tela intacta e concluía que o botão não funciona. Query segue silenciosa —
    // a tela já tem estado de erro; mutação é ação explícita e precisa responder.
    mutationCache: new MutationCache({
      onError: (erro, _vars, _ctx, mutacao) => {
        if (mutacao.options.onError) return
        // `erroTratadoNaTela` existe porque `onError` não era critério suficiente:
        // quem trata com try/catch em volta do `mutateAsync` NÃO declara onError, e
        // levava o toast genérico "Algo deu errado" por cima da mensagem específica
        // que a própria tela acabou de mostrar. O padrão continua avisando — silêncio
        // em mutação é pior —, mas agora há como declarar que a tela responde.
        if (mutacao.meta?.erroTratadoNaTela) return
        avisarErro(erro)
      },
    }),
    queryCache: new QueryCache(),
    defaultOptions: {
      queries: {
        staleTime: 30_000, // 30s — dado considerado fresco
        gcTime: 5 * 60 * 1000, // 5 min — cache em memória
        retry: repetirConsulta, // uma vez em erro de rede; nunca em 429 (limite de leitura, #1445)
        refetchOnWindowFocus: true, // revalida ao voltar à aba
        // IMPORTANTE: sem cache otimista em dados financeiros (spec §11.9)
      },
      mutations: {
        retry: 0, // sem retry em mutações (idempotência é responsabilidade do backend)
      },
    },
  })
}
